import React from 'react'
import '../../../node_modules/react-datepicker/dist/react-datepicker.css'
import { Field, ErrorMessage } from 'formik'
import { TextError } from '../TextError'
import DateView from 'react-datepicker'

const DatePicker = (props) => {
    const {name,label,...rest}=props;
  return (
  <>
         <label htmlFor={name}>{label}</label>
         <Field name={name}>
          {
            ({form,field})=>{
               const {setFieldValue}=form;
               const {value}=field

               return (
                <DateView id={name} {...field}  {...rest}  selected={value}
                        onChange={val=>setFieldValue(name,val)}
               ></DateView>
               ) 
            }
          }
         </Field>

         <ErrorMessage name={name} component={TextError} />
  </>
  )
}

export default DatePicker




